/** 选择图片后压缩为较小 JPEG File，供 OSS 直传使用。 */

function looksLikeImageFile(file: File): boolean {
  if (file.type.startsWith("image/")) {
    return true;
  }
  // 微信等环境选图时常无 MIME，仅靠扩展名判断
  return /\.(jpe?g|png|webp|heic|heif|gif|bmp)$/i.test(file.name || "");
}

export function compressFileToJpegFile(
  file: File,
  maxEdge: number,
  quality: number
): Promise<File> {
  return new Promise((resolve, reject) => {
    if (!looksLikeImageFile(file)) {
      reject(new Error("not image"));
      return;
    }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const { width, height } = img;
      if (width <= 0 || height <= 0) {
        reject(new Error("bad size"));
        return;
      }
      const scale = Math.min(maxEdge / width, maxEdge / height, 1);
      const w = Math.max(1, Math.round(width * scale));
      const h = Math.max(1, Math.round(height * scale));
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        reject(new Error("no ctx"));
        return;
      }
      ctx.drawImage(img, 0, 0, w, h);
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("compress fail"));
            return;
          }
          resolve(new File([blob], "image.jpg", { type: "image/jpeg" }));
        },
        "image/jpeg",
        quality
      );
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("load fail"));
    };
    img.src = url;
  });
}
